import { render } from "./EmployeeJournalPage.vue?vue&type=template&id=c07e0f5e&scoped=true"
import script from "./EmployeeJournalPage.vue?vue&type=script&lang=js"
export * from "./EmployeeJournalPage.vue?vue&type=script&lang=js"

import "./EmployeeJournalPage.vue?vue&type=style&index=0&id=c07e0f5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07e0f5e"]])

export default __exports__